const doc = [({"installment":"Avbetalning", "limited_subscription":"Begränsad prenumeration", "one_time":"Engångs", "subscription":"Prenumeration"})];
module.exports = doc.length <= 1 ? doc[0] : doc;